(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabecera-pa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pa-header]');
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var idSeccion = raiz.getAttribute('data-seccion');

    var previos = document.querySelectorAll('[data-pa-portal="' + idSeccion + '"]');
    for (var q = 0; q < previos.length; q++) {
      if (previos[q].parentNode) previos[q].parentNode.removeChild(previos[q]);
    }

    var estilos = raiz.getAttribute('style');
    if (estilos) {
      document.documentElement.style.cssText += ';' + estilos;
    }

    var barra = raiz.querySelector('[data-pa-barra]');
    var velo = raiz.querySelector('[data-pa-velo]');
    var drawer = raiz.querySelector('[data-pa-drawer]');
    var buscador = raiz.querySelector('[data-pa-buscador]');
    var espaciador = raiz.querySelector('[data-pa-espaciador]');
    var anuncio = barra ? barra.querySelector('[data-pa-anuncio]') : null;

    var moviles = [barra, velo, drawer, buscador];
    for (var m = 0; m < moviles.length; m++) {
      if (moviles[m]) {
        moviles[m].setAttribute('data-pa-portal', idSeccion);
        document.body.appendChild(moviles[m]);
      }
    }

    var ocultar = raiz.getAttribute('data-ocultar') === 'true';

    function alturaAnuncio() {
      return anuncio && anuncio.offsetParent !== null ? anuncio.offsetHeight : 0;
    }
    function ajustarEspaciador() {
      if (espaciador && barra) espaciador.style.height = barra.offsetHeight + 'px';
    }

    var ultimo = window.pageYOffset || 0;
    var pendiente = false;
    var umbral = 6;

    function evaluarScroll() {
      var y = window.pageYOffset || 0;
      if (y <= 4) {
        barra.style.transform = 'translateY(0)';
      } else if (ocultar) {
        if (y > ultimo + umbral) {
          barra.style.transform = 'translateY(-100%)';
        } else if (y < ultimo - umbral) {
          barra.style.transform = 'translateY(-' + alturaAnuncio() + 'px)';
        }
      } else {
        barra.style.transform = 'translateY(-' + alturaAnuncio() + 'px)';
      }
      ultimo = y;
      pendiente = false;
    }

    window.addEventListener('scroll', function () {
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(evaluarScroll);
      }
    }, { passive: true });

    window.addEventListener('resize', ajustarEspaciador);
    window.addEventListener('load', ajustarEspaciador);
    ajustarEspaciador();
    evaluarScroll();

    var mensajes = anuncio ? anuncio.querySelectorAll('[data-pa-mensaje]') : [];
    if (mensajes.length > 1) {
      var indice = 0;
      window.setInterval(function () {
        mensajes[indice].classList.remove('pa-header__mensaje--activo');
        indice = (indice + 1) % mensajes.length;
        mensajes[indice].classList.add('pa-header__mensaje--activo');
      }, 4000);
    }

    var cerrarAnuncio = anuncio ? anuncio.querySelector('[data-pa-cerrar-anuncio]') : null;
    if (cerrarAnuncio && anuncio) {
      cerrarAnuncio.addEventListener('click', function () {
        anuncio.style.display = 'none';
        ajustarEspaciador();
        evaluarScroll();
      });
    }

    var abrirMenu = barra ? barra.querySelector('[data-pa-abrir-menu]') : null;
    var cerrarMenu = drawer ? drawer.querySelector('[data-pa-cerrar-menu]') : null;
    var paneles = drawer ? drawer.querySelectorAll('[data-pa-panel]') : [];

    function activarPanel(id) {
      for (var i = 0; i < paneles.length; i++) {
        paneles[i].classList.remove('pa-header__panel--activo');
        if (paneles[i].getAttribute('data-pa-panel') === id) paneles[i].classList.add('pa-header__panel--activo');
      }
    }
    function abrirDrawer() {
      if (!drawer) return;
      activarPanel('raiz');
      drawer.classList.add('pa-header__drawer--abierto');
      drawer.setAttribute('aria-hidden', 'false');
      if (velo) velo.classList.add('pa-header__velo--visible');
      if (abrirMenu) abrirMenu.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function cerrarDrawer() {
      if (!drawer) return;
      drawer.classList.remove('pa-header__drawer--abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (velo) velo.classList.remove('pa-header__velo--visible');
      if (abrirMenu) abrirMenu.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (abrirMenu) abrirMenu.addEventListener('click', abrirDrawer);
    if (cerrarMenu) cerrarMenu.addEventListener('click', cerrarDrawer);
    if (velo) velo.addEventListener('click', cerrarDrawer);

    if (drawer) {
      var abrirBtns = drawer.querySelectorAll('[data-pa-abrir]');
      for (var a = 0; a < abrirBtns.length; a++) {
        abrirBtns[a].addEventListener('click', function () { activarPanel(this.getAttribute('data-pa-abrir')); });
      }
      var volverBtns = drawer.querySelectorAll('[data-pa-volver]');
      for (var b = 0; b < volverBtns.length; b++) {
        volverBtns[b].addEventListener('click', function () { activarPanel(this.getAttribute('data-pa-volver')); });
      }
    }

    var buscadorInput = buscador ? buscador.querySelector('[data-pa-buscador-input]') : null;
    function abrirBuscador() {
      if (!buscador) return;
      buscador.classList.add('pa-header__buscador--abierto');
      buscador.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (buscadorInput) window.setTimeout(function () { buscadorInput.focus(); }, 120);
    }
    function cerrarBuscador() {
      if (!buscador) return;
      buscador.classList.remove('pa-header__buscador--abierto');
      buscador.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    var abridores = document.querySelectorAll('[data-pa-abrir-buscador]');
    for (var c = 0; c < abridores.length; c++) {
      abridores[c].addEventListener('click', function () { cerrarDrawer(); abrirBuscador(); });
    }
    var cerradorBuscador = buscador ? buscador.querySelector('[data-pa-cerrar-buscador]') : null;
    if (cerradorBuscador) cerradorBuscador.addEventListener('click', cerrarBuscador);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrarDrawer(); cerrarBuscador(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paginaproducto-pa"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

  if (!window.paCarritoVigilado) {
    window.paCarritoVigilado = true;

    var avisarCarrito = function () {
      window.setTimeout(function () {
        try { window.dispatchEvent(new CustomEvent('ponteaura:carrito')); }
        catch (e) {
          var ev = document.createEvent('Event');
          ev.initEvent('ponteaura:carrito', true, true);
          window.dispatchEvent(ev);
        }
      }, 150);
    };

    var esRutaCarrito = function (url) {
      if (!url) return false;
      if (typeof url !== 'string') url = String(url);
      return url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 ||
             url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1;
    };

    if (window.fetch) {
      var fetchOriginal = window.fetch;
      window.fetch = function () {
        var destino = arguments[0];
        if (destino && destino.url) destino = destino.url;
        var promesa = fetchOriginal.apply(this, arguments);
        if (esRutaCarrito(destino)) {
          promesa.then(function () { avisarCarrito(); }).catch(function () {});
        }
        return promesa;
      };
    }

    if (window.XMLHttpRequest) {
      var abrirOriginal = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (metodo, url) {
        this.paUrl = url;
        return abrirOriginal.apply(this, arguments);
      };
      var enviarOriginal = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var peticion = this;
        peticion.addEventListener('load', function () {
          if (esRutaCarrito(peticion.paUrl)) avisarCarrito();
        });
        return enviarOriginal.apply(this, arguments);
      };
    }
  }

  function iniciarProd(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var handleActual = raiz.getAttribute('data-pa-track');

    try {
      if (handleActual) {
        var claveVistos = 'ponteaura_vistos';
        var vistos = JSON.parse(localStorage.getItem(claveVistos) || '[]');
        vistos = vistos.filter(function (h) { return h !== handleActual; });
        vistos.unshift(handleActual);
        localStorage.setItem(claveVistos, JSON.stringify(vistos.slice(0, 20)));
      }
    } catch (e) {}

    function formatearPrecio(centavos) {
      var valor = (centavos / 100);
      try {
        return valor.toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch (e) {
        return '$' + valor.toFixed(0);
      }
    }

    var viendo = raiz.querySelector('[data-pa-viendo]');
    if (viendo) {
      var vNum = raiz.querySelector('[data-pa-viendo-num]');
      var vMin = parseInt(viendo.getAttribute('data-min'), 10) || 6;
      var vMax = parseInt(viendo.getAttribute('data-max'), 10) || 24;
      if (vMax < vMin) vMax = vMin;

      var semilla = 0;
      var base = (handleActual || '') + new Date().toDateString() + Math.floor(Date.now() / 3600000);
      for (var s = 0; s < base.length; s++) semilla = (semilla * 31 + base.charCodeAt(s)) % 100000;

      var actual = vMin + (semilla % (vMax - vMin + 1));
      function pintarViendo() { if (vNum) vNum.textContent = actual; }
      pintarViendo();

      window.setInterval(function () {
        var paso = Math.random() < 0.5 ? -1 : 1;
        if (Math.random() < 0.35) paso = paso * 2;
        actual = Math.min(vMax, Math.max(vMin, actual + paso));
        pintarViendo();
      }, 9000);
    }

    var slides = raiz.querySelectorAll('[data-pa-slide]');
    var puntos = raiz.querySelectorAll('[data-pa-g-ir]');
    var indice = 0;

    function mostrarMedia(n) {
      if (!slides.length) return;
      indice = (n + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('pa-prod__slide--activo', i === indice);
      }
      var pts = raiz.querySelectorAll('[data-pa-g-puntos] .pa-prod__punto');
      for (var j = 0; j < pts.length; j++) pts[j].classList.toggle('pa-prod__punto--activo', j === indice);
      var minis = raiz.querySelectorAll('.pa-prod__miniatura');
      for (var k = 0; k < minis.length; k++) minis[k].classList.toggle('pa-prod__miniatura--activa', k === indice);
    }

    for (var b = 0; b < puntos.length; b++) {
      puntos[b].addEventListener('click', function () { mostrarMedia(parseInt(this.getAttribute('data-pa-g-ir'), 10)); });
    }
    var gPrev = raiz.querySelector('[data-pa-g-prev]');
    if (gPrev) gPrev.addEventListener('click', function () { mostrarMedia(indice - 1); });
    var gNext = raiz.querySelector('[data-pa-g-next]');
    if (gNext) gNext.addEventListener('click', function () { mostrarMedia(indice + 1); });

    var visor = raiz.querySelector('[data-pa-visor]');
    if (visor) {
      var x0 = null;
      visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 44) { if (dx < 0) mostrarMedia(indice + 1); else mostrarMedia(indice - 1); }
        x0 = null;
      }, { passive: true });
    }

    var lightbox = raiz.querySelector('[data-pa-lightbox]');
    var lightboxImg = raiz.querySelector('[data-pa-lightbox-img]');
    function abrirLightbox() {
      var activa = raiz.querySelector('.pa-prod__slide--activo .pa-prod__slide-img');
      if (!activa || !lightbox) return;
      lightboxImg.src = activa.getAttribute('data-pa-zoom-src') || activa.src;
      lightbox.classList.add('pa-prod__lightbox--abierto');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function cerrarLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('pa-prod__lightbox--abierto');
      lightbox.setAttribute('aria-hidden', 'true');
    }
    var zoomBtn = raiz.querySelector('[data-pa-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', abrirLightbox);
    raiz.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('pa-prod__slide-img')) abrirLightbox();
    });
    var lbCerrar = raiz.querySelector('[data-pa-lightbox-cerrar]');
    if (lbCerrar) lbCerrar.addEventListener('click', cerrarLightbox);
    if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) cerrarLightbox(); });

    var inputCant = raiz.querySelector('[data-pa-cantidad]');
    var menos = raiz.querySelector('[data-pa-menos]');
    var mas = raiz.querySelector('[data-pa-mas]');
    function ajustar(delta) {
      if (!inputCant) return;
      var v = parseInt(inputCant.value, 10) || 1;
      v = Math.max(1, v + delta);
      inputCant.value = v;
    }
    if (menos) menos.addEventListener('click', function () { ajustar(-1); });
    if (mas) mas.addEventListener('click', function () { ajustar(1); });

    var variantes = [];
    try {
      var json = raiz.querySelector('[data-pa-variantes]');
      if (json) variantes = JSON.parse(json.textContent);
    } catch (err) { variantes = []; }

    var inputId = raiz.querySelector('[data-pa-id]');
    var precioActual = raiz.querySelector('[data-pa-precio-actual]');
    var precioAntes = raiz.querySelector('[data-pa-precio-antes]');
    var barraPrecio = raiz.querySelector('[data-pa-barra-precio]');
    var agregar = raiz.querySelector('[data-pa-agregar]');
    var agregarTexto = raiz.querySelector('[data-pa-agregar-texto]');
    var barraBoton = raiz.querySelector('[data-pa-barra-agregar]');
    var barraTexto = raiz.querySelector('[data-pa-barra-texto]');
    var botonesValor = raiz.querySelectorAll('[data-pa-valor]');

    function refrescarEscalones(precio) {
      var unitarios = raiz.querySelectorAll('[data-pa-esc-unitario]');
      for (var i = 0; i < unitarios.length; i++) {
        var pct = parseInt(unitarios[i].getAttribute('data-pct'), 10) || 0;
        unitarios[i].textContent = formatearPrecio(Math.round(precio * (100 - pct) / 100));
      }
      var ahorros = raiz.querySelectorAll('[data-pa-esc-ahorro]');
      for (var j = 0; j < ahorros.length; j++) {
        var p2 = parseInt(ahorros[j].getAttribute('data-pct'), 10) || 0;
        var cant = parseInt(ahorros[j].getAttribute('data-cantidad'), 10) || 1;
        var unit = Math.round(precio * (100 - p2) / 100);
        ahorros[j].textContent = 'Ahorras ' + formatearPrecio((precio - unit) * cant);
      }
    }

    function opcionesSeleccionadas() {
      var seleccion = [];
      var opciones = raiz.querySelectorAll('[data-pa-opcion]');
      for (var i = 0; i < opciones.length; i++) {
        var activo = opciones[i].querySelector('.pa-prod__valor--activo');
        seleccion.push(activo ? activo.getAttribute('data-pa-valor-nombre') : null);
      }
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (seleccion[j] !== null && v.options[j] !== seleccion[j]) { coincide = false; break; }
        }
        if (coincide) return v;
      }
      return null;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var v = encontrarVariante(seleccion);
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precioActual) precioActual.textContent = formatearPrecio(v.price);
      if (barraPrecio) barraPrecio.textContent = formatearPrecio(v.price);
      if (precioActual) precioActual.classList.toggle('pa-prod__precio-actual--oferta', v.compare_at_price && v.compare_at_price > v.price);
      if (precioAntes) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          precioAntes.textContent = formatearPrecio(v.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      refrescarEscalones(v.price);
      var disp = v.available;
      if (agregar) agregar.disabled = !disp;
      if (barraBoton) barraBoton.disabled = !disp;
      if (agregarTexto) agregarTexto.textContent = disp ? 'Agregar al carrito' : 'Agotado';
      if (barraTexto) barraTexto.textContent = disp ? 'Agregar al carrito' : 'Agotado';
    }

    for (var vb = 0; vb < botonesValor.length; vb++) {
      botonesValor[vb].addEventListener('click', function () {
        var contenedor = this.closest('[data-pa-opcion]');
        var hermanos = contenedor.querySelectorAll('.pa-prod__valor');
        for (var h = 0; h < hermanos.length; h++) hermanos[h].classList.remove('pa-prod__valor--activo');
        this.classList.add('pa-prod__valor--activo');
        actualizar();
      });
    }

    var bloqueEsc = raiz.querySelector('[data-pa-esc]');
    if (bloqueEsc) {
      var nodosNivel = bloqueEsc.querySelectorAll('[data-pa-esc-nivel]');
      var escEstado = bloqueEsc.querySelector('[data-pa-esc-estado]');
      var escTexto = bloqueEsc.querySelector('[data-pa-esc-estado-texto]');
      var escProgreso = bloqueEsc.querySelector('[data-pa-esc-estado-progreso]');
      var escHitos = bloqueEsc.querySelector('[data-pa-esc-hitos]');
      var escVerCarrito = bloqueEsc.querySelector('[data-pa-esc-vercarrito]');
      var escConteo = bloqueEsc.querySelector('[data-pa-esc-conteo]');
      var escTextoLogrado = bloqueEsc.getAttribute('data-texto-logrado') || '&iexcl;Felicidades! Ya tienes {pct}, el descuento m&aacute;ximo.';

      if (escVerCarrito) {
        escVerCarrito.addEventListener('click', function (e) {
          if (window.PonteAuraCart && typeof window.PonteAuraCart.abrir === 'function') {
            e.preventDefault();
            window.PonteAuraCart.abrir();
          }
        });
      }

      var niveles = [];
      for (var n = 0; n < nodosNivel.length; n++) {
        niveles.push({
          nodo: nodosNivel[n],
          cantidad: parseInt(nodosNivel[n].getAttribute('data-cantidad'), 10) || 0,
          pct: parseInt(nodosNivel[n].getAttribute('data-pct'), 10) || 0
        });
      }
      niveles.sort(function (a, b) { return a.cantidad - b.cantidad; });

      var tope = niveles.length ? niveles[niveles.length - 1].cantidad : 0;

      if (escHitos && tope > 0) {
        var marcas = '';
        for (var t = 0; t < niveles.length - 1; t++) {
          marcas += '<span class="pa-prod__esc-hito" style="left:' + ((niveles[t].cantidad / tope) * 100) + '%"></span>';
        }
        escHitos.innerHTML = marcas;
      }

      function pintarEscalones(unidades) {
        var vigente = null;
        var siguiente = null;
        for (var i = 0; i < niveles.length; i++) {
          if (unidades >= niveles[i].cantidad) vigente = niveles[i];
          else if (!siguiente) siguiente = niveles[i];
        }
        for (var j = 0; j < niveles.length; j++) {
          niveles[j].nodo.classList.toggle('pa-prod__esc-nivel--vigente', vigente === niveles[j]);
        }
        if (!escEstado) return;

        var avance = tope > 0 ? Math.min(100, (unidades / tope) * 100) : 0;
        if (unidades > 0 && avance < 7) avance = 7;
        if (escProgreso) escProgreso.style.width = avance + '%';
        if (escConteo) escConteo.innerHTML = unidades + ' <small>/ ' + tope + '</small>';

        var logrado = !siguiente && vigente;
        escEstado.classList.toggle('pa-prod__esc-estado--logrado', !!logrado);
        if (escVerCarrito) escVerCarrito.hidden = !logrado;

        if (logrado) {
          escTexto.innerHTML = escTextoLogrado.replace('{pct}', '<b>' + vigente.pct + '%</b>');
          return;
        }

        var faltan = siguiente ? siguiente.cantidad - unidades : 0;
        var plural = faltan === 1 ? 'producto' : 'productos';

        if (unidades === 0) {
          escTexto.innerHTML = 'Agrega <b>' + faltan + '</b> ' + plural + ' y obt&eacute;n <b>' + siguiente.pct + '%</b> de descuento.';
        } else {
          escTexto.innerHTML = 'Llevas <b>' + unidades + '</b> ' + (unidades === 1 ? 'producto' : 'productos') +
            (vigente ? ' con <b>' + vigente.pct + '%</b>' : '') +
            '. Agrega <b>' + faltan + '</b> ' + plural + ' m&aacute;s y ' +
            (vigente ? 'subes' : 'obtienes') + ' <b>' + siguiente.pct + '%</b>.';
        }
      }

      var ultimoConteo = -1;

      function leerCarrito() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (carrito) {
            var total = carrito.item_count || 0;
            if (total !== ultimoConteo) {
              ultimoConteo = total;
              pintarEscalones(total);
            }
          })
          .catch(function () {});
      }

      function revisarVarias() {
        leerCarrito();
        window.setTimeout(leerCarrito, 500);
        window.setTimeout(leerCarrito, 1400);
        window.setTimeout(leerCarrito, 2800);
      }

      pintarEscalones(0);
      leerCarrito();

      window.addEventListener('ponteaura:carrito', revisarVarias);

      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('[data-pa-agregar], [data-pa-barra-agregar], [data-pa-add], [data-pa-rank-add], [data-pa-ofer-add], [data-pa-art-add], [data-pa-qty], [data-pa-remove], form[action*="/cart/add"] [type="submit"]')) {
          revisarVarias();
        }
      });

      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (f && f.action && f.action.indexOf('/cart/add') > -1) revisarVarias();
      });

      document.addEventListener('visibilitychange', function () { if (!document.hidden) leerCarrito(); });
      window.addEventListener('pageshow', leerCarrito);
    }

    var barraFija = raiz.querySelector('[data-pa-barra-fija]');
    if (barraFija && agregar) {
      var form = raiz.querySelector('#pa-form-producto');
      if (barraBoton && form) {
        barraBoton.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(agregar);
          else form.submit();
        });
      }
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (ent) {
            barraFija.classList.toggle('pa-prod__barra-fija--visible', !ent.isIntersecting && ent.boundingClientRect.top < 0);
            barraFija.setAttribute('aria-hidden', ent.isIntersecting ? 'true' : 'false');
          });
        }, { threshold: 0 });
        obs.observe(agregar);
      }
    }

    var entrega = raiz.querySelector('[data-pa-entrega]');
    if (entrega) {
      var min = parseInt(entrega.getAttribute('data-min'), 10) || 3;
      var max = parseInt(entrega.getAttribute('data-max'), 10) || 8;
      var hoy = new Date();
      function sumar(d) { var f = new Date(hoy); f.setDate(f.getDate() + d); return f; }
      function fmt(f) { return f.getDate() + ' ' + MESES[f.getMonth()]; }
      function rango(a, b) { return fmt(a) + ' - ' + fmt(b); }
      var fHoy = raiz.querySelector('[data-pa-fecha-hoy]');
      var fCamino = raiz.querySelector('[data-pa-fecha-camino]');
      var fRecibes = raiz.querySelector('[data-pa-fecha-recibes]');
      if (fHoy) fHoy.textContent = fmt(hoy);
      if (fCamino) fCamino.textContent = rango(sumar(1), sumar(2));
      if (fRecibes) fRecibes.textContent = rango(sumar(min), sumar(max));
    }

    mostrarMedia(0);
    actualizar();

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarLightbox(); });
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-prod]');
    for (var i = 0; i < lista.length; i++) iniciarProd(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-prod]');
    if (r) iniciarProd(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
